export enum HistoryStatus {
    UNATTENDED = 1,
    SENT = 2,
    REJECTED = 3,
    APPROVED = 4
}